import { render, staticRenderFns } from "./CrearContratoProveedorModal.vue?vue&type=template&id=9280256e&"
import script from "./CrearContratoProveedorModal.vue?vue&type=script&lang=ts&"
export * from "./CrearContratoProveedorModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9280256e', component.options)
    } else {
      api.reload('9280256e', component.options)
    }
    module.hot.accept("./CrearContratoProveedorModal.vue?vue&type=template&id=9280256e&", function () {
      api.rerender('9280256e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ContratoProveedor/CrearContratoProveedorModal.vue"
export default component.exports